<!-- desktop template -->
<div id="last-ten-container" *appIsDesktop>
  <mat-expansion-panel [expanded]="isOpen" hideToggle (opened)="toggleState()" (closed)="toggleState()">
    <mat-expansion-panel-header>
      <mat-panel-title id="last-ten-header-container">
        <span id="last-ten-header-title">
          <span id="last-ten-title" class="title">
            {{ appStrings.lastTen_title }}
          </span>
          <span id="last-ten-header-closed"
          class="crm-industrial-font icon-keyboard-arrow-down"></span>
          <span id="last-ten-header-opened"
          class="crm-industrial-font icon-keyboard-arrow-up"></span>
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ds-divider></ds-divider>
    <div id="content">
      <div class="tabs-container">
        <div id="last-ten-actions-container" class="actions-container">
          @if (activeTab === tabs.OpenQuotes) {
            <ds-button id="search" shape="rounded" size="medium" type="secondary" variant="label-icon" 
              icon="search" [label]="searchValue"
              iconPosition="right" iconStyle="material-icons-outlined" 
              (onClick)="openSearch()">
            </ds-button>
          }
          @if (activeTab === tabs.OpenQuotes) {
            <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
          }
          <ds-button id="seeAll" size="medium" type="tertiary" variant="label-icon" icon="visibility" 
            [label]="appStrings.button_seeAll"
            iconPosition="left" iconStyle="material-icons-outlined" (onClick)="handleSeeAll()">
          </ds-button>
          @if (activeTab === tabs.OpenQuotes) {
            <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
          }
          @if (activeTab === tabs.OpenQuotes) {
            <ds-button id="addNew" size="medium" type="secondary" variant="label-icon" 
              icon="add" [label]="appStrings.button_addNew"
              iconPosition="left" iconStyle="material-icons" (onClick)="handleAddNew()">
            </ds-button>
          }
        </div>
        <ds-tabs (selectedIndexChange)="onTabChange($event)" [@.disabled]="true">
          <ng-template ds-tab [label]="appStrings.menu_openQuotes">
            <div id="open-quotes-content">
              <div id="data-container" class="data-container">
                <app-open-quotes #openQuotes [accountManagerEmployeeId]="accountManagerEmployeeId" [isVisible]="isOpen"></app-open-quotes>
              </div>
            </div>
          </ng-template>
          <ng-template ds-tab [label]="appStrings.menu_openOrders">
            <div id="ln-open-orders-content">
              <div id="data-container" class="data-container">
                <app-ln-orders [accountManagerEmployeeId]="accountManagerEmployeeId" [isShipped]="false" [isVisible]="isOpen"></app-ln-orders>
              </div>
            </div>
          </ng-template>
          <ng-template ds-tab [label]="appStrings.label_submittedOrders">
            <div id="ln-open-orders-content">
              <div id="data-container" class="data-container">
                <app-ln-orders [accountManagerEmployeeId]="accountManagerEmployeeId" [isShipped]="true" [isVisible]="isOpen"></app-ln-orders>
              </div>
            </div>
          </ng-template>
        </ds-tabs>
      </div>
    </div>
  </mat-expansion-panel>
</div>

<!-- mobile template -->
<div id="last-ten-container">
  <mat-expansion-panel *appIsMobile [expanded]="false" class="mobile">
    <mat-expansion-panel-header>
      <mat-panel-title id="last-ten-header-container">
        <span class="last-ten-header-title">
          <span id="last-ten-title" class="title">
            {{ appStrings.lastTen_title }}
          </span>
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ds-divider></ds-divider>
    <div class="tabs-container">
      <ds-button-toggle-legacy class="ellipsis-toggle three-tabs" (onClick)="onTabChangeMobile($event)" [toggleValues]="mobileToggleValues" size="medium" type="outlined" [selectedIndex]="activeTab" [isMultipleSelection]="false"></ds-button-toggle-legacy>
    </div>
    <div id="quotes-actions-container" class="quotes-actions-container">
      @if (activeTab === tabs.OpenQuotes) {
        <ds-button shape="rounded" size="medium" type="secondary" variant="label-icon" icon="search" [label]="searchValue"
          iconPosition="right" iconStyle="material-icons-outlined" (onClick)="openSearch()">
        </ds-button>
      }
      @if (activeTab === tabs.OpenQuotes) {
        <ds-menu [menuOptions]="mobileMenuOptions" menu_description="none" (onClick)="handleMenuAction($event)"
          iconStyle="material-icons-outlined" icon="left-icon"
          dsButtonIcon="more_vert" dsButtonSize="medium" dsButtonType="tertiary" dsButtonVariant="label-icon" [dsButtonLabel]="appStrings.button_more">
        </ds-menu>
      }
    </div>
    @if (activeTab === tabs.OpenQuotes) {
      <div>
        <app-open-quotes #openQuotes [accountManagerEmployeeId]="accountManagerEmployeeId" [isVisible]="isOpen"></app-open-quotes>
      </div>
    }
    @if (activeTab === tabs.LNOpenOrders) {
      <div>
        <app-ln-orders [accountManagerEmployeeId]="accountManagerEmployeeId" [isShipped]="false" [isVisible]="isOpen"></app-ln-orders>
      </div>
    }
    @if (activeTab === tabs.LNSubmittedOrders) {
      <div>
        <app-ln-orders [accountManagerEmployeeId]="accountManagerEmployeeId" [isShipped]="true" [isVisible]="isOpen"></app-ln-orders>
      </div>
    }
  </mat-expansion-panel>
</div>